import React from 'react';
import { Label } from 'semantic-ui-react';
import { formatCurrency } from '../services';

/**
 * Adjustment/WriteOff label group cell
 * Displays write-off type and amount with click handler
 */
const AdjustmentWriteOffCell = ({
    type, // 'writeoff' or 'adjustment'
    writeOffType,
    amount,
    onClickHandler
}) => {
    const multiplicant = type == 'writeoff' ? -1 : 1;
    return (
        <td>
            <Label.Group className="d-flex">
                <Label className="user-select-none mr-1 pr-2 pl-2" content={writeOffType} />
                <Label
                    basic={true}
                    color="orange"
                    content={+amount ? formatCurrency(amount * multiplicant) : '-'}
                    className="cursorPointer pr-2 pl-2"
                    onClick={onClickHandler}
                />
            </Label.Group>
        </td>
    );
};

export default AdjustmentWriteOffCell;
